module.exports = __webpack_public_path__ + "img/icon_h-gas.ff5ce895.png";